import { render, staticRenderFns } from "./CrmRelativeCell.vue?vue&type=template&id=4d620302&scoped=true"
import script from "./CrmRelativeCell.vue?vue&type=script&lang=js"
export * from "./CrmRelativeCell.vue?vue&type=script&lang=js"
import style0 from "./CrmRelativeCell.vue?vue&type=style&index=0&id=4d620302&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d620302",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/crm1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d620302')) {
      api.createRecord('4d620302', component.options)
    } else {
      api.reload('4d620302', component.options)
    }
    module.hot.accept("./CrmRelativeCell.vue?vue&type=template&id=4d620302&scoped=true", function () {
      api.rerender('4d620302', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CreateCom/CrmRelativeCell.vue"
export default component.exports